export const ORGANIZER_PAGE_KEYWORD = 'me';
export const MEETING_TYPE_ROUTE_KEYWORD = 'meetingtype';
export const ORGANIZER_NEW_MEETING_TYPE_ROUTE_KEYWORD = 'new';
export const ATTENDEE_PAGE_KEYWORD = 'user';
export const ATTENDEE_MEETING_DETAILS_ROUTE_KEYWORD = 'booking';
export const BOOK_WITH_ME_PATH_NAME = 'bookwithme';
